import imgHoangSaIslands from 'assets/images/EVG/HoangSa.png';
import imgTruongSaIslands from 'assets/images/EVG/TruongSa.png';
import ChargeHelper from 'features/Charge/chargeHelper';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useWindowSize from 'hooks/useWindowSize';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useSelector } from 'react-redux';
import StationInfoBoxView from '../StationInfoBoxView';

ChargeStationBingMapView2.propTypes = {
  iframeMode: PropTypes.bool,
};

const MAP_KEY = process.env.REACT_APP_BING_MAP_API_KEY;
const grayscaleMapStyle = {
  elements: {
    water: { fillColor: '#d1d1d1' }, // Màu xám cho nước
    area: { fillColor: '#e5e5e5' }, // Màu xám nhạt cho khu vực
    tollRoad: { fillColor: '#bababa' }, // Màu xám đậm cho đường thu phí
    arterialRoad: { fillColor: '#d7d7d7' }, // Màu xám trung bình cho đường chính
    road: { fillColor: '#ffffff' }, // Màu trắng cho đường
    street: { fillColor: '#f7f7f7' }, // Màu xám nhạt cho đường phố
    transit: { fillColor: '#d1d1d1' }, // Màu xám cho giao thông công cộng
    building: { fillColor: '#cfcfcf' }, // Màu xám cho tòa nhà
    background: { fillColor: '#f5f5f5' }, // Màu nền
  },
  version: '1.0',
};

function ChargeStationBingMapView2({ iframeMode = false }) {
  // MARK: ---- PROPERTIES ----
  const { user } = useSelector((state) => state.auth);
  const [filter, setFilter] = useState({
    areaId: '',
    vehicleType: '',
    type: '',
    chargingSpeed: '',
  });
  const [stationList, setStationList] = useState([]);
  useEffect(() => {
    let params = { ...filter, managedBy: 'ADMIN', mapView: 1, limit: 5000 };
    params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
    ChargeHelper.API.requestGetChargeStationList(params).then((response) => {
      setStationList(response?.chargeStations ?? []);
    });
  }, [filter]);
  const [mapCenter, setMapCenter] = useState([21.03478655865438, 105.79108899756075]);
  const [mapZoom, setMapZoom] = useState(12);
  // khu vuc
  const areaTree = useSelector((state) => state.app.areaTree);
  const areaProvinceList = useMemo(() => {
    return ChargeHelper.Utils.getAreaListByType([areaTree], 'P');
  }, [areaTree]);
  const areaProvinceOptions = useMemo(() => {
    return _.map(areaProvinceList, (item) => {
      return {
        name: item.name,
        value: item.areaId,
      };
    });
  }, [areaProvinceList]);
  const [selectedAreaProvince, setSelectedAreaProvince] = useState();
  const areaDistrictList = useMemo(() => {
    if (!selectedAreaProvince) return [];
    return ChargeHelper.Utils.getSubAreaListByParentId([areaTree], selectedAreaProvince?.areaId);
  }, [areaTree, selectedAreaProvince]);
  const areaDistrictOptions = useMemo(() => {
    return _.map(areaDistrictList, (item) => {
      return {
        name: item.name,
        value: item.areaId,
      };
    });
  }, [areaDistrictList]);
  const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();
  const [contentHeight, setContentHeight] = useState('100vh');
  const windowSize = useWindowSize();
  useEffect(() => {
    const header = document.getElementById('kt_header');
    const headerMobile = document.getElementById('kt_header_mobile');
    const footer = document.getElementById('kt_footer');
    console.log(
      header?.clientHeight,
      headerMobile?.clientHeight,
      footer?.clientHeight,
      windowSize?.height
    );
    const height =
      windowSize?.height -
      header?.clientHeight -
      footer?.clientHeight -
      headerMobile?.clientHeight -
      1;
    console.log({ height });
    setContentHeight(`${height}px`);
  }, [windowSize]);
  // BING MAP
  const mapRef = useRef(null); // Tham chiếu đến bản đồ
  const infoboxRef = useRef(null); // Tham chiếu đến Infobox
  const [MicrosoftLoaded, setMicrosoftLoaded] = useState(false);
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://www.bing.com/api/maps/mapcontrol?callback=GetMap&key=${MAP_KEY}&setMkt=vi-VN&setLang=vi`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    window.GetMap = () => {
      setMicrosoftLoaded(true);
    };
  }, []);
  useEffect(() => {
    if (MicrosoftLoaded && !mapRef.current) {
      initializeMap();
    }
  }, [MicrosoftLoaded]);
  useEffect(() => {
    if (MicrosoftLoaded) {
      hideInfobox();
      updatePushpins();
    }
  }, [stationList, MicrosoftLoaded]);

  // MARK: ---- METHODS ----
  const initializeMap = () => {
    const mapElement = document.getElementById('station-map-view-id');
    if (!mapElement || !MicrosoftLoaded) {
      console.error('Map element is not ready or Microsoft is not loaded.');
      return;
    }

    const map = new Microsoft.Maps.Map(mapElement, {
      center: new Microsoft.Maps.Location(mapCenter[0], mapCenter[1]),
      zoom: mapZoom,
      customMapStyle: grayscaleMapStyle,
      // mapTypeId: Microsoft.Maps.mapTypeId.grayscale,
      showZoomButtons: false,
      showMapTypeSelector: false,
      showLocateMeButton: false,
    });

    mapRef.current = map;
    // Tạo Infobox và lưu vào ref
    const infobox = new Microsoft.Maps.Infobox(map.getCenter(), {
      visible: false,
    });
    infobox.setMap(map);
    infoboxRef.current = infobox;

    // Thêm sự kiện click vào bản đồ để ẩn Infobox
    Microsoft.Maps.Events.addHandler(map, 'click', () => {
      hideInfobox();
    });

    function TopographicOverlay(bounds, imageSrc) {
      this.bounds = bounds;
      this.imageSrc = imageSrc;
      this.imgElement = null;
    }

    TopographicOverlay.prototype = new Microsoft.Maps.CustomOverlay();

    TopographicOverlay.prototype.onAdd = function () {
      const img = document.createElement('img');
      img.src = this.imageSrc;
      img.style.position = 'absolute';
      img.style.pointerEvents = 'none';
      this.imgElement = img;
      this.setHtmlElement(img);
    };

    TopographicOverlay.prototype.onLoad = function () {
      const repositionOverlay = () => {
        const topLeft = map.tryLocationToPixel(
          this.bounds.getNorthwest(),
          Microsoft.Maps.PixelReference.control
        );
        const bottomRight = map.tryLocationToPixel(
          this.bounds.getSoutheast(),
          Microsoft.Maps.PixelReference.control
        );

        if (topLeft && bottomRight) {
          this.imgElement.style.left = `${topLeft.x}px`;
          this.imgElement.style.top = `${topLeft.y}px`;
          this.imgElement.style.width = `${bottomRight.x - topLeft.x}px`;
          this.imgElement.style.height = `${bottomRight.y - topLeft.y}px`;
        }
      };

      Microsoft.Maps.Events.addHandler(map, 'viewchange', repositionOverlay);
      repositionOverlay();
    };

    TopographicOverlay.prototype.onRemove = function () {
      Microsoft.Maps.Events.removeHandler(this.viewChangeEvent);
      if (this.imgElement && this.imgElement.parentNode) {
        this.imgElement.parentNode.removeChild(this.imgElement);
      }
      this.imgElement = null;
    };

    const boundHoangSa = Microsoft.Maps.LocationRect.fromCorners(
      new Microsoft.Maps.Location(17.0, 111.5),
      new Microsoft.Maps.Location(18.0, 112.5)
    );
    const overlayHoangSa = new TopographicOverlay(boundHoangSa, imgHoangSaIslands);
    map.layers.insert(overlayHoangSa);

    const boundTruongSa = Microsoft.Maps.LocationRect.fromCorners(
      new Microsoft.Maps.Location(11.0, 113.5),
      new Microsoft.Maps.Location(12.0, 114.5)
    );
    const overlayTruongSa = new TopographicOverlay(boundTruongSa, imgTruongSaIslands);
    map.layers.insert(overlayTruongSa);
  };

  const showInfobox = (station, location) => {
    if (infoboxRef.current) {
      const infoboxHtml = ReactDOMServer.renderToString(
        <div className="position-relative">
          <StationInfoBoxView station={station} />
          {!iframeMode && (
            <div
              id="infobox-div"
              className="position-absolute w-100 h-100 left-0 top-0 cursor-pointer"
            ></div>
          )}
        </div>
      );

      infoboxRef.current.setOptions({
        location: location,
        htmlContent: infoboxHtml,
        visible: true,
        offset: new Microsoft.Maps.Point(-150, 54),
      });
      // Gắn sự kiện click vào nút sau khi Infobox được hiển thị
      setTimeout(() => {
        const div = document.getElementById('infobox-div');
        if (div) {
          div.addEventListener('click', () => {
            Utils.openInNewTab(`${AppRoute.stationList}/${station.stationId}`);
          });
        }
      }, 0);
    }
  };
  const hideInfobox = () => {
    if (infoboxRef.current) {
      infoboxRef.current.setOptions({ visible: false });
    }
  };
  const updatePushpins = () => {
    if (!mapRef.current) return;

    // Xóa tất cả các pushpins cũ
    mapRef.current.entities.clear();

    // Thêm các pushpins mới
    stationList.forEach((station) => {
      if (Utils.isValid(station.latitude) && Utils.isValid(station.longitude)) {
        const location = new Microsoft.Maps.Location(station?.latitude, station?.longitude);
        const pushpin = new Microsoft.Maps.Pushpin(location, {
          icon: ChargeHelper.Utils.getChargeStationPinIcon(station.status),
          title: '',
        });

        // Thêm sự kiện click cho pushpin
        Microsoft.Maps.Events.addHandler(pushpin, 'click', () => {
          showInfobox(station, location);
        });

        // Thêm pushpin vào bản đồ
        mapRef.current.entities.push(pushpin);
      }
    });
  };
  const updateMapCenter = (location) => {
    if (mapRef.current) {
      mapRef.current.setView({
        center: location, // Cập nhật vị trí trung tâm
        zoom: mapZoom, // Giữ nguyên mức zoom hiện tại
      });
    }
  };

  const chargingSpeedOptions = [
    { value: '', name: 'Tất cả' },
    { value: 'NORMAL', name: 'Sạc thường: ≤ 11 kW' },
    { value: 'FAST', name: 'Sạc nhanh: 20 kW → 60 kW' },
    { value: 'SUPERFAST', name: 'Sạc siêu nhanh: ≥ 120kW' },
  ]
  const [isFilterExpanded, setIsFilterExpanded] = useState(true);

  return (
    <div
      className="position-relative"
      style={{
        height: contentHeight,
      }}
    >
      {/* BING MAP */}
      <div className="w-100 h-100" id="station-map-view-id"></div>

      {/* FILTER */}
      <div className="position-absolute left-0 top-0 w-100 h-100" style={{ pointerEvents: 'none' }}>
        <div className="h-100 d-flex flex-column-reverse flex-sm-column">
          <div className="row m-0 p-0 px-2 pt-4">
            <div className="col-xl-3 col-lg-4 col-sm-6 mb-4 px-2" style={{ zIndex: 100 }}>
              {UIHelper.buildCard(
                <div style={{ pointerEvents: 'visible' }}>
                  {UIHelper.buildCardHeader(
                    'Tìm kiếm trạm sạc',
                    false,
                    <button
                      type="button"
                      className="d-flex align-items-center justify-content-center border-0 rounded"
                      style={{
                        width: 35,
                        height: 35,
                        backgroundColor: AppColors.gray[200],
                        cursor: 'pointer',
                        transition: 'transform 0.3s ease',
                        transform: isFilterExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
                      }}
                      onClick={() => setIsFilterExpanded(!isFilterExpanded)}
                    >
                      <i className="fas fa-chevron-up" style={{ color: AppColors.gray[800], }} />
                    </button>,
                    true
                  )}

                  <div className=""
                    style={{
                      maxHeight: isFilterExpanded ? '1200px' : '0px',
                      opacity: isFilterExpanded ? 1 : 0,
                      transition: 'all 0.4s ease-in-out',
                    }}>
                    <div className="row m-0 p-0 px-2">
                      {/* tinh/thanh pho */}
                      <div className="col-12 mb-4 px-2">
                        {UIHelper.buildFormLabel('Tỉnh/Thành phố')}
                        <KTBSDropdown
                          name="province"
                          toggleElement={
                            <button className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`} type="button">
                              {selectedAreaProvince?.name ?? 'Chọn tỉnh/thành phố'}
                            </button>
                          }
                          selectedValue={selectedAreaProvince?.areaId}
                          dropdownMenuItems={areaProvinceOptions}
                          dropdownMenuClassName="overflow-auto w-100"
                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                          onChange={(value) => {
                            setSelectedAreaProvince(_.find(areaProvinceList, (item) => item.areaId === value));
                            setFilter({ ...filter, areaId: value });
                          }}
                          isDropdownForm={true}
                          searchable
                          liveSearch={false}
                          onTextChanged={(text) => { }}
                        />
                      </div>

                      {/* quan/huyen */}
                      <div className="col-12 mb-4 px-2">
                        {UIHelper.buildFormLabel('Phường/Xã')}
                        <KTBSDropdown
                          name="district"
                          toggleElement={
                            <button className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`} type="button">
                              {selectedAreaDistrict?.name ?? 'Chọn phường/xã'}
                            </button>
                          }
                          selectedValue={selectedAreaDistrict?.areaId}
                          dropdownMenuItems={areaDistrictOptions}
                          dropdownMenuClassName="overflow-auto w-100"
                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                          onChange={(value) => {
                            const area = _.find(areaDistrictList, (item) => item.areaId === value);
                            setSelectedAreaDistrict(area);
                            setFilter({ ...filter, areaId: value });
                          }}
                          isDropdownForm={true}
                          searchable
                          liveSearch={false}
                          onTextChanged={(text) => { }}
                        />
                      </div>

                      {/* Loại phương tiện, Loại trụ sạc, Công suất giữ nguyên như cũ */}
                      <div className="col-12 mb-4 px-2">
                        {UIHelper.buildFormLabel('Loại phương tiện')}
                        <KTBSDropdown
                          name="vehicleType"
                          toggleElement={
                            <button className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between" type="button">
                              {_.find(ChargeHelper.Data.vehicleTypeOptions, (item) => item?.value === filter.vehicleType)?.name ?? 'Tất cả'}
                            </button>
                          }
                          selectedValue={filter.vehicleType}
                          dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...ChargeHelper.Data.vehicleTypeOptions]}
                          dropdownMenuClassName="overflow-auto w-100"
                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                          onChange={(value) => setFilter({ ...filter, vehicleType: value })}
                          isDropdownForm={true}
                        />
                      </div>

                      <div className="col-12 mb-4 px-2">
                        {UIHelper.buildFormLabel('Loại trụ sạc')}
                        <KTBSDropdown
                          name="type"
                          toggleElement={
                            <button className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between" type="button">
                              {_.find(ChargeHelper.Data.chargePointTypeOptions, (item) => item?.value === filter.type)?.name ?? 'Tất cả'}
                            </button>
                          }
                          selectedValue={filter.type}
                          dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...ChargeHelper.Data.chargePointTypeOptions]}
                          dropdownMenuClassName="overflow-auto w-100"
                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                          onChange={(value) => setFilter({ ...filter, type: value })}
                          isDropdownForm={true}
                        />
                      </div>

                      <div className="col-12 mb-4 px-2">
                        {UIHelper.buildFormLabel('Công suất')}
                        <KTBSDropdown
                          name="chargingSpeed"
                          toggleElement={
                            <button className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between" type="button">
                              {_.find(chargingSpeedOptions, (item) => item?.value === filter.chargingSpeed)?.name ?? 'Tất cả'}
                            </button>
                          }
                          selectedValue={filter.chargingSpeed}
                          dropdownMenuItems={chargingSpeedOptions}
                          dropdownMenuClassName="overflow-auto w-100"
                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                          onChange={(value) => setFilter({ ...filter, chargingSpeed: value })}
                          isDropdownForm={true}
                        />
                      </div>
                    </div>

                    {/* actions */}
                    <div className="px-4 py-4" style={{ borderTop: `1px dashed ${AppColors.gray[300]}` }}>
                      {UIHelper.buildNegativeButton('Xóa bộ lọc', () => {
                        setSelectedAreaProvince(null);
                        setSelectedAreaDistrict(null);
                        setFilter({ areaId: '' });
                      })}
                    </div>
                  </div>
                </div>,
                false
              )}
            </div>
            <div className="col"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChargeStationBingMapView2;
